import { render, staticRenderFns } from "./ButtonsPage.vue?vue&type=template&id=584a6653&"
import script from "./ButtonsPage.vue?vue&type=script&lang=ts&"
export * from "./ButtonsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports